// WashoffForm.jsx
import { useState, useEffect } from "react"
import { UniversalDropDown } from "@fileops/swmm-react"
import { Button } from '@mui/material'
import "../../css/DemoCode.css"

/**
 * Dry Weather Form is a group of data inputs usually shown when clicking on Node->Inflows. 
 * This form is contained within InflowsDialog.
 * 
 * @param {JSON} model A SWMM model in JSON format. In most cases this
 * is a 'submodel' containing only a copy of the affected sections. Using a copy allows
 * for continuous react-style editing without forcing the model to run on every keystroke.
 * @param {function} setModel Update function for updating 'model'.
 * @param {JSON} fullModel The 'full' SWMM model that contains supporting data for this component.
 * @param {string} target The name of the node targetted by this form.
 * @returns UI for interactive swmm modeling.
 */
export default function WashoffForm({ fullModel, setFullModel, target}) {
  const [constituent, setConstituent] = useState('*')
  const [constituents]                = useState(Object.keys(fullModel.POLLUTANTS).length===0?[]:Object.keys(fullModel.POLLUTANTS))
  const [func, setFunc]               = useState('NONE')
  const [funcs]                       = useState(['NONE', 'EXP', 'RC', 'EMC'])
  const [coeff1, setCoeff1]           = useState(0)
  const [coeff2, setCoeff2]           = useState(0)
  const [eCleaning, setECleaning]     = useState(0)
  const [eBMP, setEbmp]               = useState(0)

  // If a constituent has been selected but the fullModel does not contain a WASHOFF for 
  // the constituent, then apply default values. Otherwise, use the fullModel WASHOFF values.
  useEffect(()=>{
    if(constituent !== '*'){
      if(fullModel.WASHOFF[target] && fullModel.WASHOFF[target][constituent]){
        setFunc(fullModel.WASHOFF[target][constituent].Function)
        setCoeff1(fullModel.WASHOFF[target][constituent].Coeff1)
        setCoeff2(fullModel.WASHOFF[target][constituent].Coeff2)
        setECleaning(fullModel.WASHOFF[target][constituent].Ecleaning)
        setEbmp(fullModel.WASHOFF[target][constituent].Ebmp)
      } else {
        setFunc('NONE')
        setCoeff1(0)
        setCoeff2(0)
        setECleaning(0)
        setEbmp(0)
      }
    }

  }, [constituent])

  const saveEdits = () => {
    if(constituent !== '*'){
      // If this is an external time series based function, use timeSeries and scaleFactor
      setFullModel(prev => ({
        ...prev, 
        WASHOFF: {
          ...prev.WASHOFF, 
          [target]: {
            ...prev.WASHOFF[target],
            [constituent]: {
              Function: func,
              Coeff1: coeff1,
              Coeff2: coeff2,
              Ecleaning: eCleaning,
              Ebmp: eBMP
            }
          }
        }
      }))
    }
  }

  return(
    <>
    {
      <>
        <div>
          <Button fullWidth onClick={saveEdits} >Save Edits</Button>
        </div>
        {(
          target && 
          target.length > 0 &&
          <label className='editor-small' >Constituent
            <UniversalDropDown style={{padding: '0'}}
              IDs={constituents} 
              selectText={"Select a Constituent"} 
              value={constituent}
              onChange={(val)=>{setConstituent(val)}} >
            </UniversalDropDown>
          </label>
        )}
        {(
          target && 
          target.length > 0 &&
          <label className='editor-small' >Function
            <UniversalDropDown style={{padding: '0'}}
              IDs={funcs} 
              selectText={"Select a Function"} 
              value={func}
              onChange={(val)=>{setFunc(val)}} >
            </UniversalDropDown>
          </label>
        )}
        {(
          target && 
          target.length > 0 &&
          <label className='editor-small' >Coefficient
            <input  type = "text"
                    style={{width: '95%', display: 'flex'}}
                    onChange={(e)=>{setCoeff1(e.target.value)}}
                    value={coeff1}
                    id={'coeff1_'+target}
            />
          </label>
        )}
        {(
          target && 
          target.length > 0 &&
          <label className='editor-small' >Exponent
            <input  type = "text"
                    style={{width: '95%', display: 'flex'}}
                    onChange={(e)=>{setCoeff2(e.target.value)}}
                    value={coeff2}
                    id={'coeff2_'+target}
            />
          </label>
        )}
        {(
          target && 
          target.length > 0 &&
          <label className='editor-small' >Cleaning Effic.
            <input  type = "text"
                    style={{width: '95%', display: 'flex'}}
                    onChange={(e)=>{setECleaning(e.target.value)}}
                    value={eCleaning}
                    id={'eCleaning_'+target}
            />
          </label>
        )}
        {(
          target && 
          target.length > 0 &&
          <label className='editor-small' >BMP Effic
            <input  type = "text"
                    style={{width: '95%', display: 'flex'}}
                    onChange={(e)=>{setEbmp(e.target.value)}}
                    value={eBMP}
                    id={'eBMP_'+target}
            />
          </label>
        )}
      </>
        }
    </>
  )
}